













































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  Alert, NoticeClass, Dialog,
} from '@kasasa/fbase-components/lib';
import {
  CycleValidationPostingFile, CycleValidationApproval, CycleValidationSnapshot, ApprovalResource, CycleApprovalState,
} from '@/api/rewardsvalidation/';
import { CoreUserInfoResource, CoreUserInfo } from '@/api/coreuserinfo/';
import ConfirmationDialog from '@/components/rewardsvalidation/ConfirmationDialog.vue';

@Component({
  computed: mapState(['fiId']),
  components: {
    ConfirmationDialog,
  },
})
export default class ValidationApprovalSection extends Vue {
  @Prop() snapshot: CycleValidationSnapshot | undefined;

  @Prop({ default: null }) hasUnapprovedZeroByteFiles!: boolean | null;

  @Prop({ default: null }) hasOutOfDateReportFile!: boolean | null;

  @Prop({ default: null }) isReportFileListInitialized!: boolean | null;

  @Prop() approvalResource!: ApprovalResource;

  @Prop() files!: CycleValidationPostingFile[];

  @Prop({ default: true }) allowReject!: boolean;

  @Prop({ default: 'Approve' }) approveText!: string;

  @Prop({ default: 'Reject' }) rejectText!: string;

  workingSnapshot: CycleValidationSnapshot | undefined;

  fiId!: string;

  loadingApproval: boolean = false;

  savingApproval: boolean = false;

  savingRejection: boolean = false;

  approval: CycleValidationApproval | null = null;

  approvalUserName: string | null = null;

  showConfirmationDialog: boolean = false;

  confirmationDialogTitle: string = '';

  confirmationDialogMessage: string = '';

  confirmationDialogExpectedText: string = '';

  // Make the enum visible to the template
  CycleApprovalState:any = CycleApprovalState;

  @Inject('CoreUserInfoResource')
  coreUserInfoResource!: CoreUserInfoResource;

  mounted() {
    this.loadApproval();
  }

  @Watch('snapshot')
  loadApproval() {
    this.approval = null;
    this.approvalUserName = null;
    this.loadingApproval = true;
    this.workingSnapshot = this.snapshot;

    if (this.workingSnapshot) {
      this.approvalResource.getApproval(this.fiId, this.workingSnapshot.id).then((result: CycleValidationApproval) => {
        this.approval = result;
        this.fetchApprovalUserName();
      }).catch((error: any) => {
        if (error.response && error.response.status !== 404) {
          this.showErrorMessage(error);
        }
      }).finally(() => {
        this.loadingApproval = false;
      });
    }
  }

  fetchApprovalUserName() {
    if (this.approval && this.approval.approvalUserId) {
      this.coreUserInfoResource.getCoreUserInfo(this.fiId, this.approval.approvalUserId).then((user: CoreUserInfo) => {
        let userName: string = '';

        if (user.firstName && user.firstName.length > 0) {
          userName = user.firstName;
          if (user.lastName && user.lastName.length > 0) {
            userName += ' ';
          }
        }

        if (user.lastName && user.lastName.length > 0) {
          userName += user.lastName;
        }

        if (userName.length === 0) {
          userName = 'User';
        }

        this.approvalUserName = userName;

        this.$emit('gotApprovalState', this.approval!.approvalState, this.approval!.approvalDateTime, this.approvalUserName);
      }).catch((error: any) => {
        this.approvalUserName = 'User';
        this.showErrorMessage(error);
      });
    }
  }

  showApprovalDialog() {
    const viewState = this;
    const onShowApprovalDialog : Function = () => {
      viewState.confirmationDialogTitle = 'Confirm Approval';
      viewState.confirmationDialogMessage = 'Confirm validation results approval by entering "approved" below.';
      viewState.confirmationDialogExpectedText = 'approved';
      viewState.showConfirmationDialog = true;
    };

    if ((this.hasOutOfDateReportFile && this.workingSnapshot)) {
      const dialogMessage = 'Not All Reports are current. Are you sure you want to approve Rewards Validation at this time and send old reports?';
      const dialog: Dialog = new Dialog('Confirm', dialogMessage);
      dialog.setAcceptLabel('OK');
      dialog.setDeclineLabel('Cancel');
      this.$store.dispatch('notices/add', dialog).then((ok) => {
        if (ok === 'accept') {
          onShowApprovalDialog();
        }
      });
    } else {
      onShowApprovalDialog();
    }
  }

  showRejectionDialog() {
    this.confirmationDialogTitle = 'Confirm Rejection';
    this.confirmationDialogMessage = 'Confirm validation results rejection by entering "rejected" below.';
    this.confirmationDialogExpectedText = 'rejected';
    this.showConfirmationDialog = true;
  }

  onConfirmed() {
    if (this.confirmationDialogExpectedText === 'approved') {
      this.savingApproval = true;
      this.saveApproval('APPROVED');
    } else {
      this.savingRejection = true;
      this.saveApproval('REJECTED');
    }
  }

  saveApproval(approvalState: string) {
    if (this.workingSnapshot) {
      this.approvalResource.saveApproval(this.fiId, this.workingSnapshot, approvalState, this.files).then(
        (result: CycleValidationSnapshot | CycleValidationApproval) => {
        // Type check
          if ((result as CycleValidationSnapshot).jsonString) {
            this.workingSnapshot = result as CycleValidationSnapshot;
          }
          this.loadApproval();
        },
      ).catch((error: any) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.savingApproval = false;
        this.savingRejection = false;
      });
    }
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
